import styled from 'styled-components';

import { Text as UnstyledText } from 'features/common/components/Text';

export const Text = styled(UnstyledText)<{ isPunchup?: boolean }>`
	font-size: 16px;
	line-height: 24px;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey20 : theme.colors.white)};
`;
